module.exports = __webpack_public_path__ + "img/theos_logo.af16054b.svg";